import React from "react";
import ReportTypeScreen from "../../../Components/Reports/ReportTypeScreen";

function ReportedProfiles() {
  return <ReportTypeScreen reportType="profile" />;
}

export default ReportedProfiles;
